import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [showQuoteForm, setShowQuoteForm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    const form = e.currentTarget;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://readdy.ai/api/form/d5j6cmagbpr25eot44rg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setShowSuccess(true);
        form.reset();
        setTimeout(() => {
          setShowQuoteForm(false);
          setShowSuccess(false);
        }, 2000);
      }
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <footer className="bg-gradient-to-br from-amber-50 to-blue-50 pt-0 pb-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-12 gap-4 sm:gap-6 md:gap-8 lg:gap-6 mb-4 sm:mb-6 md:mb-8">
            {/* Company Info */}
            <div className="col-span-2 md:col-span-2 lg:col-span-3 -mt-2 sm:-mt-4">
              <img 
                src="https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/e0b3cf16f09f7185e56ad37c0d6a5ff1.png" 
                alt="Yuma Spray Foam Pros Logo" 
                className="h-28 sm:h-40 lg:h-52 w-auto -mb-6 sm:-mb-10 lg:-mb-12 -mt-4 sm:-mt-6 lg:-mt-8"
              />
              <p className="text-gray-600 leading-relaxed text-xs sm:text-sm lg:text-base">
                Professional spray foam insulation services in Yuma, Arizona since 2001. Licensed, insured, and committed to excellence.
              </p>
            </div>

            {/* Quick Links */}
            <div className="lg:col-span-2">
              <h4 className="font-bold text-gray-900 mb-2 sm:mb-3 md:mb-4 text-xs sm:text-sm md:text-base">Quick Links</h4>
              <ul className="space-y-1 sm:space-y-2 md:space-y-3">
                <li>
                  <a href="/" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-blue-900 transition-colors cursor-pointer">
                    Home
                  </a>
                </li>
                <li>
                  <a href="/about-yuma-insulation" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-blue-900 transition-colors cursor-pointer">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="/insulation-services-arizona" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-blue-900 transition-colors cursor-pointer">
                    Services
                  </a>
                </li>
                <li>
                  <a href="/yuma-projects" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-blue-900 transition-colors cursor-pointer">
                    Projects
                  </a>
                </li>
                <li>
                  <a href="/yuma-insulation-faq" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-blue-900 transition-colors cursor-pointer">
                    FAQ
                  </a>
                </li>
              </ul>
            </div>

            {/* Services */}
            <div className="lg:col-span-2">
              <h4 className="font-bold text-gray-900 mb-2 sm:mb-3 md:mb-4 text-xs sm:text-sm md:text-base">Services</h4>
              <ul className="space-y-1 sm:space-y-2 md:space-y-3">
                <li>
                  <a href="/insulation-services-arizona" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-blue-900 transition-colors cursor-pointer">
                    Insulation Services
                  </a>
                </li>
                <li>
                  <a href="/residential-insulation-yuma" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-blue-900 transition-colors cursor-pointer">
                    Residential
                  </a>
                </li>
                <li>
                  <a href="/commercial-insulation-yuma" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-blue-900 transition-colors cursor-pointer">
                    Commercial
                  </a>
                </li>
                <li>
                  <a href="/closed-cell-spray-foam-yuma" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-blue-900 transition-colors cursor-pointer">
                    Closed Cell Foam
                  </a>
                </li>
                <li>
                  <a href="/open-cell-spray-foam-yuma" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-blue-900 transition-colors cursor-pointer">
                    Open Cell Foam
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="col-span-2 sm:col-span-2 md:col-span-2 lg:col-span-5">
              <h4 className="font-bold text-gray-900 mb-2 sm:mb-3 md:mb-4 text-xs sm:text-sm md:text-base">Contact Us</h4>
              <ul className="space-y-2 sm:space-y-3 lg:space-y-4">
                <li className="flex items-start">
                  <i className="ri-mail-line text-blue-900 mt-0.5 sm:mt-1 mr-1.5 sm:mr-2 md:mr-3 text-xs sm:text-sm md:text-base"></i>
                  <div>
                    <p className="text-[10px] sm:text-xs md:text-sm text-gray-500">Email</p>
                    <a href="mailto:tom@yumasprayfoaminsulationpro.com" className="text-xs sm:text-sm md:text-base text-gray-900 font-semibold hover:text-blue-900 cursor-pointer whitespace-nowrap">
                      tom@yumasprayfoaminsulationpro.com
                    </a>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="ri-phone-line text-blue-900 mt-0.5 sm:mt-1 mr-1.5 sm:mr-2 md:mr-3 text-xs sm:text-sm md:text-base"></i>
                  <div>
                    <p className="text-[10px] sm:text-xs md:text-sm text-gray-500">Phone</p>
                    <a href="tel:+19284278140" className="text-xs sm:text-sm md:text-base text-gray-900 font-semibold hover:text-blue-900 cursor-pointer">
                      (928) 427-8140
                    </a>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="ri-time-line text-blue-900 mt-0.5 sm:mt-1 mr-1.5 sm:mr-2 md:mr-3 text-xs sm:text-sm md:text-base"></i>
                  <div>
                    <p className="text-[10px] sm:text-xs md:text-sm text-gray-500">Hours</p>
                    <p className="text-xs sm:text-sm md:text-base text-gray-900 font-semibold">Mon-Sun: 8AM - 6PM</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-200 pt-3 sm:pt-4 md:pt-6 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-600 text-[10px] sm:text-xs md:text-sm mb-2 sm:mb-3 md:mb-0 text-center md:text-left">
              © 2024 Yuma Spray Foam Insulation. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-blue-900 text-[10px] sm:text-xs md:text-sm transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Quote Form Modal */}
      {showQuoteForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-gradient-to-r from-orange-600 to-orange-700 text-white p-6 rounded-t-xl flex justify-between items-center">
              <div>
                <h3 className="text-2xl font-bold">Request Your Free Quote</h3>
                <p className="text-orange-100 mt-1">We'll get back to you within 24 hours</p>
              </div>
              <button
                onClick={() => setShowQuoteForm(false)}
                className="text-white hover:bg-white/20 rounded-full w-10 h-10 flex items-center justify-center transition-all cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <form id="footer_contact_form" data-readdy-form onSubmit={handleSubmit} className="p-6 space-y-4">
              {showSuccess && (
                <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg flex items-center space-x-2">
                  <i className="ri-checkbox-circle-fill text-xl"></i>
                  <span>Thank you! We'll contact you soon.</span>
                </div>
              )}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="group">
                  <label className="block text-sm font-semibold text-gray-700 mb-2 transition-colors duration-300 group-focus-within:text-orange-600">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm transition-all duration-300"
                    placeholder="John Smith"
                  />
                </div>

                <div className="group">
                  <label className="block text-sm font-semibold text-gray-700 mb-2 transition-colors duration-300 group-focus-within:text-orange-600">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm transition-all duration-300"
                    placeholder="john@example.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="group">
                  <label className="block text-sm font-semibold text-gray-700 mb-2 transition-colors duration-300 group-focus-within:text-orange-600">
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm transition-all duration-300"
                    placeholder="(928) 427-8140"
                  />
                </div>

                <div className="group">
                  <label className="block text-sm font-semibold text-gray-700 mb-2 transition-colors duration-300 group-focus-within:text-orange-600">
                    Property Type *
                  </label>
                  <div className="relative">
                    <select
                      name="property_type"
                      required
                      className="w-full px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm cursor-pointer transition-all duration-300 appearance-none bg-white"
                    >
                      <option value="">Select type</option>
                      <option value="Residential">Residential</option>
                      <option value="Commercial">Commercial</option>
                      <option value="Industrial">Industrial</option>
                    </select>
                    <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                      <i className="ri-arrow-down-s-line text-gray-500 text-xl transition-transform duration-300 group-focus-within:text-orange-600 group-focus-within:rotate-180"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div className="group">
                <label className="block text-sm font-semibold text-gray-700 mb-2 transition-colors duration-300 group-focus-within:text-orange-600">
                  Service Needed *
                </label>
                <div className="relative">
                  <select
                    name="service"
                    required
                    className="w-full px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm cursor-pointer transition-all duration-300 appearance-none bg-white"
                  >
                    <option value="">Select service</option>
                    <option value="Spray Foam Insulation">Spray Foam Insulation</option>
                    <option value="Attic Insulation">Attic Insulation</option>
                    <option value="Wall Insulation">Wall Insulation</option>
                    <option value="Crawl Space Insulation">Crawl Space Insulation</option>
                    <option value="Other">Other</option>
                  </select>
                  <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                    <i className="ri-arrow-down-s-line text-gray-500 text-xl transition-transform duration-300 group-focus-within:text-orange-600 group-focus-within:rotate-180"></i>
                  </div>
                </div>
              </div>

              <div className="group">
                <label className="block text-sm font-semibold text-gray-700 mb-2 transition-colors duration-300 group-focus-within:text-orange-600">
                  Project Details
                </label>
                <textarea
                  name="project_details"
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm resize-none transition-all duration-300"
                  placeholder="Tell us about your project, property size, timeline, etc."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">Maximum 500 characters</p>
              </div>

              <div className="group">
                <label className="block text-sm font-semibold text-gray-700 mb-2 transition-colors duration-300 group-focus-within:text-orange-600">
                  Preferred Contact Method
                </label>
                <div className="flex flex-wrap gap-3">
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input type="radio" name="contact_method" value="Phone" className="cursor-pointer accent-orange-600" />
                    <span className="text-sm text-gray-700">Phone</span>
                  </label>
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input type="radio" name="contact_method" value="Email" className="cursor-pointer accent-orange-600" />
                    <span className="text-sm text-gray-700">Email</span>
                  </label>
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input type="radio" name="contact_method" value="Text" className="cursor-pointer accent-orange-600" />
                    <span className="text-sm text-gray-700">Text</span>
                  </label>
                </div>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-orange-600 hover:bg-orange-700 text-white py-4 rounded-lg font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Sending...' : 'Submit Quote Request'}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
